var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolicitudesNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#7000FF",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 12.3684C23.793 12.3684 24.1925 12.5368 24.507 12.8653C24.83 13.2105 25 13.5895 25 14.0526V23.3158C25 23.7789 24.83 24.1579 24.507 24.5032C24.1925 24.8316 23.793 25 23.3 25H9.7C9.207 25 8.8075 24.8316 8.493 24.5032C8.17 24.1579 8 23.7789 8 23.3158V14.0526C8 13.5895 8.17 13.2105 8.493 12.8653C8.8075 12.5368 9.207 12.3684 9.7 12.3684H13.1V10.6842C13.1 10.1958 13.27 9.8 13.593 9.48842C13.9075 9.16842 14.307 9 14.8 9H18.2C18.693 9 19.0925 9.16842 19.407 9.48842C19.73 9.8 19.9 10.1958 19.9 10.6842V12.3684H23.3ZM9.7 14.0526V23.3158H23.3V14.0526H9.7ZM18.2 12.3684V10.6842H14.8V12.3684H18.2Z",
    fill: "#7000FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitudesNews);
export default __webpack_public_path__ + "static/media/solicitudesNews.ff19a5eea556e10737399da998979c1d.svg";
export { ForwardRef as ReactComponent };